import { actions } from './doctorProcessReport/actions'
import { getters } from './doctorProcessReport/getters'
import { state } from './doctorProcessReport/state'
import { mutations } from './doctorProcessReport/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
